import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useScrolled } from '../hooks/useScrolled';

const NAV_TABS: [string, string][] = [
  ['/', 'Home'],
  ['/about', 'About'],
  ['/contact', 'Contact Us'],
  ['/privacy', 'Privacy Policy'],
  ['/terms', 'Terms of Use'],
];

function Nav() {
  const scrolled = useScrolled();
  const navigate = useNavigate();

  return (
    <header className={`nav-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner">
        <button className="nav-brand" onClick={() => navigate('/')}>
          Hold On
        </button>
        <nav className="nav-pill">
          {NAV_TABS.map(([path, label]) => (
            <NavLink
              key={path}
              to={path}
              end={path === '/'}
              className={({ isActive }) => `nav-tab${isActive ? ' active' : ''}`}
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default Nav;
